import React from 'react';
import './SkylabHeader.css';

interface SkylabHeaderProps {
  logo?: string;
  brandColor?: string;
  partnerName?: string;
}

const SkylabHeader: React.FC<SkylabHeaderProps> = ({ 
  logo, 
  brandColor = '#007bff', 
  partnerName = 'MyLodgeTax' 
}) => {
  const metaTag = document.querySelector('meta[name="admin-root-url"]');
  const adminRootUrl = metaTag?.getAttribute('content') || '';

  const supportUrl = 'https://www.avalara.com/mylodgetax/en/contact-us.html';

  return (
    <header className="skylab-header" style={{ '--brand-color': brandColor } as React.CSSProperties}>
      <div className="header-container">
        <div className="logo-section">
          <img
            src="/assets/images/avalara-logo.svg"
            alt="Avalara logo"
            className="avalara-logo hide-xs"
          />
          <span className="mylodgetax-text">MyLodgeTax</span>
        </div>

        <nav className="header-nav">
          <a
            href={supportUrl}
            className="nav-item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/assets/images/support-icon.svg"
              alt="Support"
              className="support-icon-img"
            />
            <span>Support</span>
          </a>
          <a
            href={adminRootUrl || '#'}
            className="nav-item login-item"
          >
            <img
              src="/assets/images/login-icon.svg"
              alt="Login"
              className="login-icon"
            />
            <span>Login</span>
          </a>
        </nav>
      </div>
    </header>
  );
};

export default SkylabHeader; 